export const GET_ALL_BANNER_REQUEST = "GET_ALL_BANNER_REQUEST";
export const GET_ALL_BANNER_FAILURE = "GET_ALL_BANNER_FAILURE";
export const GET_ALL_BANNER_SUCCESS = "GET_ALL_BANNER_SUCCESS";

export const GET_ALL_SPECIAL_OFFER_BANNER_REQUEST = "GET_ALL_SPECIAL_OFFER_BANNER_REQUEST";
export const GET_ALL_SPECIAL_OFFER_BANNER_FAILURE = "GET_ALL_SPECIAL_OFFER_BANNER_FAILURE";
export const GET_ALL_SPECIAL_OFFER_BANNER_SUCCESS = "GET_ALL_SPECIAL_OFFER_BANNER_SUCCESS";

export const CREATE_BANNER_REQUEST = "CREATE_BANNER_REQUEST";
export const CREATE_BANNER_FAILURE = "CREATE_BANNER_FAILURE";
export const CREATE_BANNER_SUCCESS = "CREATE_BANNER_SUCCESS";

export const UPDATE_BANNER_REQUEST = "UPDATE_BANNER_REQUEST";
export const UPDATE_BANNER_FAILURE = "UPDATE_BANNER_FAILURE";
export const UPDATE_BANNER_SUCCESS = "UPDATE_BANNER_SUCCESS";

export const DELETE_BANNER_REQUEST = "DELETE_BANNER_REQUEST";
export const DELETE_BANNER_FAILURE = "DELETE_BANNER_FAILURE";
export const DELETE_BANNER_SUCCESS = "DELETE_BANNER_SUCCESS";